<template>
  <div class="tabs-wrapper">

    <div v-if="showLeftChapterArrow" class="scroll-arrow left" @click="scrollLeft">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" :stroke="`var(--primary-color)`" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <div class="tab-list" ref="tabList" @scroll="handleChapterTabScroll">
      <div
          v-for="(subject, index) in subjects"
          :key="subject.id"
          class="tab-item"
          :class="{ active: currentChapterActiveTab === index }"
          @click="handleTabClick(index, subject.id)"
      >
        {{ subject.title }}
      </div>
    </div>

    <div v-if="showRightChapterArrow" class="scroll-arrow right" @click="scrollRight">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M9 6L15 12L9 18" :stroke="`var(--primary-color)`" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

  </div>
</template>

<script>
  export default {
    name: "ProductContentClassesTabs",
    props: {
      subjects: Array
    },
    data() {
      return {
        currentChapterActiveTab: 0,
        showLeftChapterArrow: false,
        showRightChapterArrow: false,
        selectedSubjectId: null
      }
    },
    methods: {
      handleTabClick(index, subjectId) {
        this.currentChapterActiveTab = index;
        this.selectedSubjectId = subjectId;
        const newQuery = { ...this.$route.query, chapterId: subjectId };
        this.$router.push({ query: newQuery }).catch(() => {});
      },
      scrollLeft() {
        const el = this.$refs.tabList;
        const children = el.children;

        for (let i = children.length - 1; i >= 0; i--) {
          const child = children[i];
          if (child.offsetLeft < el.scrollLeft - 2) {
            el.scrollTo({ left: child.offsetLeft, behavior: "smooth" });
            break;
          }
        }
      },
      scrollRight() {
        const el = this.$refs.tabList;
        const children = el.children;

        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (child.offsetLeft > el.scrollLeft + 2) {
            el.scrollTo({ left: child.offsetLeft, behavior: "smooth" });
            break;
          }
        }
      },
      handleChapterTabScroll() {
        const el = this.$refs.tabList;
        this.showLeftChapterArrow = el.scrollLeft > 2;
        this.showRightChapterArrow = el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
      },
      loadActiveTabIndex() {
        const activeSubjectIndex = this.subjects.findIndex(subject => String(subject.id) === String(this.$route.query.chapterId));

        // if filters are applied and active subject wasnt in
        // subjects list then now assign first subject as active
        if (this.subjects.length > 0 && activeSubjectIndex === -1) {
          this.selectedSubjectId = this.subjects[0].id;
          this.currentChapterActiveTab = 0;

          this.$router.replace({
            query: { ...this.$route.query, chapterId: this.selectedSubjectId }
          });

        } else {
          this.currentChapterActiveTab = activeSubjectIndex;
        }

        this.$nextTick(this.handleChapterTabScroll);
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.handleChapterTabScroll();
      });
    },

    watch: {

      subjects() {
        this.loadActiveTabIndex();
      },

      $route(to) {
        if (to.query.chapterId) {
          this.selectedSubjectId = to.query.chapterId;
          const index = this.subjects.findIndex(s => s.id === this.selectedSubjectId);
          if (index !== -1) {
            this.currentChapterActiveTab = index;
          }
        }
      },
    },

    created() {
      this.loadActiveTabIndex();

    }
  }
</script>

<style scoped>
.tabs-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
  margin-bottom: 1rem;
}

.tab-list {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex: 1;
}

.tab-list::-webkit-scrollbar {
  display: none;
}

.tab-item {
  padding: 12px 20px;
  cursor: pointer;
  font-weight: 500;
  flex-shrink: 0;
  color: #444;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.tab-item.active {
  color: var(--primary-color, #007bff);
  border-color: var(--primary-color, #007bff);
}

.tab-item:hover {
  background-color: #f6f6f6;
}

.scroll-arrow {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  background-color: white;
}

.scroll-arrow.left {
  left: 0;
  color: var(--primary-color);
  background: white;
}

.scroll-arrow.right {
  right: 0;
  color: var(--primary-color);
  background: white;
}
</style>